import { render, staticRenderFns } from "./LeaguePodiumCard.vue?vue&type=template&id=b83b71ea&scoped=true"
import script from "./LeaguePodiumCard.vue?vue&type=script&lang=js"
export * from "./LeaguePodiumCard.vue?vue&type=script&lang=js"
import style0 from "./LeaguePodiumCard.vue?vue&type=style&index=0&id=b83b71ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b83b71ea",
  null
  
)

export default component.exports